import { render, staticRenderFns } from "./pageTab.vue?vue&type=template&id=6162132a"
import script from "./pageTab.vue?vue&type=script&lang=js"
export * from "./pageTab.vue?vue&type=script&lang=js"
import style0 from "./pageTab.vue?vue&type=style&index=0&id=6162132a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports